<template>
    <div
            :class="['trigger-field', { 'open-bg': isOpen }]"
            @click="toggleDropdown"
            :style="{ minHeight: fieldHeight + 'px' }"
    >
        <i :class="iconClass" v-if="icon"></i>
        <div class="trigger-label-container">
            <span :class="['trigger-label', { 'with-value': selection && selection.length || dateRangeDisplay }]">{{
                    label
                }}</span>
            <div class="trigger-value-container">

                <span class="trigger-value" v-if="type==='daterange'">
                    {{ dateRangeDisplay }}
                </span>

                <span v-else-if="type==='single'" class="trigger-value">
                    {{ getItemText(selection) }}
                </span>

                <span v-else v-for="(value, index) in selection" :key="index" class="trigger-value">
                    {{ getItemText(value) }}
                    <span class="remove-icon-container">
                        <i
                                class="fal fa-times-circle remove-icon"
                                @click.stop="emitRemove(value)"
                        />
                    </span>
                </span>
            </div>
        </div>
        <i v-if="loading" class="fal fa-spinner-third fa-spin loader-icon"></i>
        <i v-else class="fal fa-chevron-down chevron-icon"></i>
    </div>
</template>

<script>
export default {
    props: {
        icon: { type: String },
        label: { type: String },
        isOpen: { type: Boolean, default: false },
        fieldHeight: { type: Number, default: 44 },
        loading: { type: Boolean, default: false },
        items: { type: Array },
        type: {
            type: String,
            required: true,
            validator: (value) => ["single", "multiple", "daterange"].includes(value),
        },
        selection: { type: [String, Number, Array, Object], default: null },
        itemText: { type: String, default: "text" },
        itemValue: { type: String, default: "value" },

    },
    computed: {
        iconClass() {
            return `${ this.icon } trigger-icon`;
        },
        dateRangeDisplay() {
            try {
                if (!this.selection || !this.selection.start || !this.selection.end) return "";

                const formatDate = (date) => {
                    const day = String(date.getDate()).padStart(2, "0");
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const year = date.getFullYear();
                    return `${ day }.${ month }.${ year }`;
                };
                return `${ formatDate(this.selection.start) } - ${ formatDate(this.selection.end) }`;
            } catch (e) {
                return ""
            }
        },
        itemTextMap() {
            if (!this.items) return {};
            return this.items.reduce((map, item) => {
                map[item[this.itemValue]] = this.t(item[this.itemText]);
                return map;
            }, {});
        },
    },
    methods: {
        toggleDropdown() {
            this.$emit("toggle");
        },
        emitRemove(value) {
            this.$emit("remove", value);
        },
        getItemText(value) {
            return this.itemTextMap[value] || "";
        },
    },
};
</script>

<style scoped>
.trigger-field {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 7px 12px;
    background-color: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    min-height: 44px;
}

.trigger-label-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.trigger-label {
    font-size: 15px;
    color: rgba(141, 153, 146, 1);
    margin-bottom: 0;
}

.trigger-label.with-value {
    font-size: 11px;
    line-height: 1;
    color: rgba(141, 153, 146, 1);
}


.trigger-icon {
    width: 24px;
    min-width: 24px;
    text-align: center;
    color: rgba(100, 100, 100, 1);
    font-size: 20px;
}

.chevron-icon {
    color: gray;
    font-size: 20px;
    transition: transform 0.2s ease-in-out;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.loader-icon {
    color: gray;
    font-size: 20px;
    animation: spin 1s linear infinite;
}

.open-bg .chevron-icon {
    transform: rotate(180deg);
}

.open-bg {
    background-color: rgba(224, 224, 224, 1);
}

.trigger-value-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
}

.trigger-value {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 600;
    color: #000;
    max-width: 100%;
}

.trigger-value .remove-icon {
    font-size: 14px;
    color: #f41823;
    padding-top: 1px;
}

.remove-icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
}


</style>
